<template>
  <div class="not-found">
    <div class="not-found__content">
      <h1 class="not-found__name">404</h1>
      <span class="not-found__text">Страница не найдена</span>
      <div class="not-found__btn-container">
        <v-btn @click="$router.go(-1)" class="orange-button not-found__btn">Назад</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    layout: 'main'
  }
</script>

<style lang="scss" scoped>
  .not-found {
    margin-top: 50px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .not-found__name {
      display: block;
      font-weight: bold;
      font-size: 96px;
      text-align: center;
    }

    .not-found__text {
      display: block;
      font-weight: bold;
      font-size: 48px;
      text-align: center;
    }

    .not-found__btn-container {
      display: flex;
      justify-content: center;
    }

    .not-found__btn {
      margin-top: 25px;
      display: block;
    }
  }

</style>
